import { toSmithersProVenueRequest } from "@/lib/smithers-provenue"
import type { SmithersProVenueSelection } from "@/types/provenue-instance"
import type { CreateSmithersDeviceRequest, UpdateSmithersDeviceRequest } from "@/types/smithers-device"

const textFields = ["facilityCode", "venueId", "areaCode", "deviceCode", "nteClubCode"] as const
const numberFields = ["matchThreshold", "validationTimeoutMs"] as const
export type SmithersDeviceFormConfig = Record<typeof textFields[number] | typeof numberFields[number], { value: string; useDefault: boolean }>

export function toSmithersDeviceRequest(
  identity: Pick<CreateSmithersDeviceRequest, "clientId" | "deviceId" | "sotiDeviceId">,
  config: SmithersDeviceFormConfig,
  vendor: "global" | "ProVenue" | "Orion",
  selection: SmithersProVenueSelection,
): CreateSmithersDeviceRequest {
  const request = {
    clientId: identity.clientId.trim(), deviceId: identity.deviceId.trim(), sotiDeviceId: identity.sotiDeviceId.trim(),
  }
  if (!request.clientId || !request.deviceId || !request.sotiDeviceId) throw new Error("Client ID, Device ID, and SOTI Device ID are required")
  if (Array.from(request.clientId).length > 100 || Array.from(request.deviceId).length > 100) throw new Error("Client ID and Device ID must not exceed 100 characters")
  return { ...request, ...toSmithersDeviceUpdate(config, vendor, selection) }
}

export function toSmithersDeviceUpdate(config: SmithersDeviceFormConfig, vendor: "global" | "ProVenue" | "Orion", selection: SmithersProVenueSelection): UpdateSmithersDeviceRequest {
  const request: UpdateSmithersDeviceRequest = { ...toSmithersProVenueRequest(selection) }
  if (vendor !== "global") request.validationVendor = vendor
  for (const field of textFields) if (!config[field].useDefault) request[field] = config[field].value
  for (const field of numberFields) {
    if (config[field].useDefault) continue
    const value = Number(config[field].value)
    const max = field === "matchThreshold" ? 2147483647 : Number.MAX_SAFE_INTEGER
    if (!config[field].value.trim() || !Number.isSafeInteger(value) || value < 0 || value > max) throw new Error(`${field} must be an integer between 0 and ${max}`)
    request[field] = value
  }
  return request
}
